import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { LoginService } from 'src/app/shared/service/login/login.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent {
  showPassword: boolean = false;
  forgotPassword: boolean = true;
  sentOtp: boolean = false;
  loginForm!: FormGroup;
  username: any;
  otpControls = Array(6).fill('');
  otpValue = '';
  isOtpRequired: boolean = false;
  @ViewChildren('otpBox') otpBoxes!: QueryList<ElementRef>;
  isSubmitting: boolean = false;
  constructor(
    private router: Router,
    private loginService: LoginService,
    private toastr: ToastrService,
  ) {
    this.loginForm = new FormGroup(
      {
        userName: new FormControl('', [Validators.required]),
        password: new FormControl('', [Validators.required]),

        newPassword: new FormControl('', [
          Validators.required,
          Validators.minLength(6),
        ]),
        confirmPassword: new FormControl('', [Validators.required]),
      },
      {
        validators: this.passwordMatchValidator,
      },
    );
  }
  ngOnInit(): void {
    this.username = localStorage.getItem('username');
    if (this.username) {
      this.router.navigate(['/home']);
    }
  }
  passwordMatchValidator(control: AbstractControl): any {
    const password = control.get('newPassword')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;

    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  onSubmit() {
    this.isSubmitting = true;
    let payload = {
      username: this.loginForm.get('userName')?.value,
      otp: this.otpValue,
    };
    this.loginService.verifyOtp(payload).subscribe(
      (data: any) => {
         sessionStorage.clear();
        localStorage.clear();
        this.isSubmitting = false;
        if (data.access_token) {
          localStorage.setItem('username', data.response);
          localStorage.setItem('authToken', data.access_token);
          localStorage.setItem('authRefToken', data.refresh_token);
          localStorage.setItem('subUsername', data.main_username);
          localStorage.setItem('loginPic', data.pic);
          localStorage.setItem('email', data.email);

          if (data.response === 'Bunge Shipping') {
            localStorage.setItem('module', 'Port Performance');
            this.router.navigate(['/home']);
          } else if(data.pic === 'meraki_phjo' || data.pic === 'meraki_naba' || data.pic === 'meraki_maga'){
            localStorage.setItem('module', 'Demurrage');
            this.router.navigate(['/home']);
          }else {
            localStorage.setItem('module', 'Sailing Performance');
            this.router.navigate(['/home']);
          }
        }
      },
      (error) => {
        this.isSubmitting = false;
        if (error.error.response) {
          this.toastr.error(error.error.response);
        } else {
          this.toastr.error(ToasterMessages.Error);
        }
      },
    );
  }
  onLogin() {
    this.isSubmitting = true;
    let payload = {
      username: this.loginForm.get('userName')?.value,
      password: this.loginForm.get('password')?.value,
    };
    let username = this.loginForm.get('userName')?.value;
    this.loginService.login(payload).subscribe(
      (data: any) => {
        this.isSubmitting = false;
        if (data !== 'OTP sent to your registered email') {
          if (data === 'Bunge Shipping') {
            localStorage.setItem('module', 'Port Performance');
            this.router.navigate(['/home']);
          }else if(username === 'meraki_phjo' || username === 'meraki_naba' || username === 'meraki_maga'){
            localStorage.setItem('module', 'Demurrage');
            this.router.navigate(['/home']);
          } else {
            localStorage.setItem('module', 'Sailing Performance');
            this.router.navigate(['/home']);
          }
        } else {
          this.isOtpRequired = true;
          this.toastr.success(data);
        }
      },
      (error) => {
        this.isSubmitting = false;
        console.error('Error:', error);

        if (error.error.response) {
          this.toastr.error(ToasterMessages.InvalidMessage);
        } else {
          this.toastr.error(ToasterMessages.Error);
        }
      },
    );
  }
  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    const value = input.value.replace(/[^0-9]/g, '');
    input.value = value;

    if (value && index < 5) {
      this.otpBoxes.toArray()[index + 1].nativeElement.focus();
    }

    this.collectOtp();
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    if (event.key === 'Backspace' && input.value === '' && index > 0) {
      this.otpBoxes.toArray()[index - 1].nativeElement.focus();
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const pasted = event.clipboardData?.getData('text') ?? '';
    const numbers = pasted.replace(/\D/g, '').slice(0, 6);

    if (numbers.length === 6) {
      const boxes = this.otpBoxes.toArray();
      numbers.split('').forEach((digit, i) => {
        boxes[i].nativeElement.value = digit;
      });

      boxes[5].nativeElement.focus();
      this.collectOtp();
    }
  }

  collectOtp() {
    this.otpValue = this.otpBoxes
      .toArray()
      .map((box) => box.nativeElement.value)
      .join('');
  }

  onForgotClick() {
    this.forgotPassword = !this.forgotPassword;
  }

  sendOtpClick() {
    let payload = {
      username: this.loginForm.get('userName')?.value,
    };
    this.loginService.sendOtp(payload).subscribe(
      (data: any) => {
        this.toastr.success(data.response);
        this.sentOtp = true;
        this.isOtpRequired = true;
      },
      (error) => {
        if (error.error.response) {
          this.toastr.error(error.error.response);
        } else {
          this.toastr.error(ToasterMessages.Error);
        }
      },
    );
  }
  newPasswordClick() {
    let payload = {
      username: this.loginForm.get('userName')?.value,
      password: this.loginForm.get('newPassword')?.value,
      otp: this.otpValue,
    };
    this.loginService.passwordChange(payload).subscribe(
      (data: any) => {
        this.toastr.success(data.response);
        this.sentOtp = false;
        this.isOtpRequired = false;
        this.forgotPassword = true;
      },
      (error) => {
        if (error.error.response) {
          this.toastr.error(error.error.response);
        } else {
          this.toastr.error(ToasterMessages.Error);
        }
      },
    );
  }
}
